import { IconButton, Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const HomeTopCategoriesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
  margin-top: 16px;
`;

const CategoryImage = styled(Image)`
  border-radius: 50px;
  object-fit: cover;
`;

const CategoryItem = styled(Typography)`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 8px;
  text-align: center;
  transition: all 0.2s ease-in-out;

  &:hover ${CategoryImage} {
    box-shadow: var(--shadow-m);
  }
`;

const HomeTopCategories = styled.div`
  align-items: center;
  display: flex;
  gap: 24px;
  height: 120px;
  margin-bottom: 16px;
  margin-top: 16px;
`;

const NavigationButton = styled(IconButton)``;

const CategorySkeleton = styled.div`
  align-items: center;
  display: flex;
`;

const CategoryName = styled(Typography)`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  height: 42px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ActionWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
`;

export {
  ActionWrapper,
  CategoryImage,
  CategoryItem,
  CategoryName,
  CategorySkeleton,
  HomeTopCategories,
  HomeTopCategoriesWrapper,
  NavigationButton
};
